import { Environment } from '@abp/ng.core';

const baseUrl = 'https://warranty.casper-electric.com';

export const environment = {
  production: true,
  sentry: {
    dsn: 'https://6903c038479dfb4e63adc6313c39d5bd@o4505792581140480.ingest.us.sentry.io/4510775874158592',
    environment: 'production',
    enabled: true
  },
  application: {
    baseUrl,
    name: 'WARR',
    logoUrl: '',
  },
  oAuthConfig: {
    issuer: 'https://usermanagerment-api.casper-electric.com',
    redirectUri: baseUrl,
    clientId: 'api-resource',
    responseType: 'code',
    scope: 'Portal WARR MDM HR Backend',
  },
  apis: {
    default: {
      url: 'https://gateway-api.casper-electric.com/warr',
      urlNew: 'https://gateway-api.casper-electric.com/',
    },
    login: {
      url: 'https://usermanagerment.casper-electric.com',
      urlOld: 'https://auth.casper-electric.com/Account/Login',
    },
    auth: {
      url: 'https://usermanagerment-api.casper-electric.com',
    },
    mdm: {
      url: 'https://portal-api.casper-electric.com/mdm',
    },
    hr: {
      url: 'https://portal-api.casper-electric.com/hr',
    },
    warr: {
      url: 'https://gateway-api.casper-electric.com/warr',
    },
    bd: {
      url: 'https://portal-api.casper-electric.com/bd',
    },
    station: {
      url: 'https://gateway-api.casper-electric.com/warranty-station',
    },
    new_warranty: {
      url: 'https://gateway-api.casper-electric.com/new-warranty',
    },
  },
  localization: {
    defaultResourceName: 'WARR',
  }
} as Environment;
